import { Alert, Snackbar } from "@mui/material";
import { useFrozenValue } from "../hooks/useFrozenValue";

export default function WarningPopup({
  message,
  onClose,
  severity = "error",
  autoHideDuration = 5000,
}) {
  const open = Boolean(message);
  const displayed = useFrozenValue({ message, severity }, open);

  return (
    <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
      <Alert severity={displayed.severity} onClose={onClose}>
        {displayed.message}
      </Alert>
    </Snackbar>
  );
}
